const MAX_TOASTS = 5;

const DEFAULT_DURATION = {
    success: 8000,
    info: 8000,
    error: 0,
    warning: 0,
};

const TYPE_LABELS = {
    success: 'Success',
    error: 'Error',
    info: 'Info',
    warning: 'Warning',
};

let listeners = [];
let toasts = [];
let idCounter = 0;

export function normalizeToastMessage(input) {
    if (input === null || input === undefined) return '';

    if (typeof input === 'string') return input.trim();

    if (typeof input === 'number' || typeof input === 'boolean') {
        return String(input);
    }

    if (input.message && typeof input.message === 'string') {
        return input.message.trim();
    }

    if (input.response?.data !== undefined) {
        return normalizeToastMessage(input.response.data);
    }

    if (typeof input === 'object') {
        if (typeof input.text === 'string') return input.text.trim();
        if (typeof input.msg === 'string') return input.msg.trim();
        if (typeof input.error === 'string') return input.error.trim();

        try {
            const serialized = JSON.stringify(input);
            if (serialized && serialized !== '{}') return serialized;
        } catch (_) {
            return 'An unexpected error occurred.';
        }
    }

    return String(input);
}

export function normalizeToastType(type) {
    const normalized = (type || 'info').toString().toLowerCase();
    if (['success', 'error', 'info', 'warning'].includes(normalized)) {
        return normalized;
    }
    return 'info';
}

export function getToastTypeLabel(type) {
    return TYPE_LABELS[normalizeToastType(type)] || TYPE_LABELS.info;
}

function notifyListeners() {
    const snapshot = [...toasts];
    listeners.forEach((listener) => listener(snapshot));
}

export function pushToast({ type, text, duration }) {
    const message = normalizeToastMessage(text);
    if (!message) return;

    const toastType = normalizeToastType(type);
    const toast = {
        id: ++idCounter,
        type: toastType,
        text: message,
        duration: duration ?? DEFAULT_DURATION[toastType] ?? 8000,
    };

    toasts = [toast, ...toasts].slice(0, MAX_TOASTS);
    notifyListeners();
}

export function dismissToast(id) {
    toasts = toasts.filter((toast) => toast.id !== id);
    notifyListeners();
}

export function clearToasts() {
    toasts = [];
    notifyListeners();
}

export function subscribeToToasts(listener) {
    listeners.push(listener);
    listener([...toasts]);

    return () => {
        listeners = listeners.filter((item) => item !== listener);
    };
}